import { render, staticRenderFns } from "./NpaInitiative.vue?vue&type=template&id=4250151b&scoped=true"
import script from "./NpaInitiative.vue?vue&type=script&lang=js"
export * from "./NpaInitiative.vue?vue&type=script&lang=js"
import style0 from "./NpaInitiative.vue?vue&type=style&index=0&id=4250151b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4250151b",
  null
  
)

export default component.exports